import React, { useState, useRef, useEffect } from "react";
import { AddressSuggestions, DaDataSuggestion, DaDataAddress } from "react-dadata";
import "react-dadata/dist/react-dadata.css";

type CityInputProps = {
  value: string;
  onChange: (city: string) => void;
  disabled?: boolean;
};

const token = process.env.REACT_APP_DADATA;

function CityInput({ value, onChange, disabled }: CityInputProps) {
  const [suggestion, setSuggestion] = useState<DaDataSuggestion<DaDataAddress> | undefined>(undefined);
  const [isValid, setIsValid] = useState(true);
  const [inputKey, setInputKey] = useState(0);
  const lastSelectedCity = useRef<string | null>(null);
  const [wasEdited, setWasEdited] = useState(false);
  const [displayValue, setDisplayValue] = useState(value);

  useEffect(() => {
    if (value && !suggestion) {
      setSuggestion({
        value: value,
        unrestricted_value: value,
        data: {
          city: value,
          city_type_full: "город"
        } as DaDataAddress
      });
      lastSelectedCity.current = value;
      setDisplayValue(value);
    }
  }, []);

  useEffect(() => {
    setDisplayValue(value);
  }, [value]);

  const handleChange = (s?: DaDataSuggestion<DaDataAddress>) => {
    if (s?.data.city) {
      const citySuggestion = {
        ...s,
        value: s.data.city
      };
      setSuggestion(citySuggestion);
      onChange(s.data.city);
      setDisplayValue(s.data.city);
      lastSelectedCity.current = s.data.city;
      setIsValid(true);
      setWasEdited(true);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setDisplayValue(newValue);
    onChange(newValue);
    setIsValid(true);
    setWasEdited(true);
  };

  const handleBlur = () => {
    if (wasEdited && displayValue !== lastSelectedCity.current) {
      onChange("");
      setDisplayValue("");
      setSuggestion(undefined);
      setIsValid(false);
      setInputKey(prev => prev + 1);
      lastSelectedCity.current = null;
    }
  };

  return (
    <div>
      <AddressSuggestions
        key={inputKey}
        token={token}
        value={suggestion || undefined} 
        onChange={handleChange}
        filterFromBound="city"
        filterToBound="city"
        filterLocations={[{ city_type_full: "город" }]}
        inputProps={{
          placeholder: "Москва",
          value: displayValue,
          onChange: handleInputChange,
          onBlur: handleBlur,
          className: "reg-input",
          disabled: disabled
        }}
        renderOption={s => <div>{s.data.city}</div>}
      />
      {!isValid && <div style={{ color: "red" }}>Выберите город из списка</div>}
    </div>
  );
}

export default CityInput;